import React, { lazy, useMemo, useRef, useState } from 'react';
import withSuspense from '../../helpers/withSuspense.jsx';
import ButtonSkeleton from '../../skeleton_loaders/common/ButtonSkeleton.jsx';
import ToggleButtonGroup from '../common/ToggleButtonGroup.jsx';
import SkeletonGrid from '../../skeleton_loaders/common/SkeletonGrid.jsx';
import ResourceLayout from './ResourceLayout.jsx';
import Button from '../bootstrap/Button.jsx';
import { FaIcon } from '../common/Icons.jsx';
import { usePersonFilter } from './hooks/usePersonFilter.jsx';

const PresetDropdown = withSuspense(lazy(() => import('../task/top/PresetDropdown.jsx')), ButtonSkeleton);
const ResourceGrid = withSuspense(lazy(() => import('./ResourceGrid.jsx')), (props) => <SkeletonGrid gridHeight={props.height} />);

const DEFAULT_HEIGHT = 'calc(100vh - 300px)';

function ResourceProgrammeList({
  programmeId,
  projectId,
  permissions = {},
  months,
  viewMode = false,
  initialGroupBy = 'role',
  height = DEFAULT_HEIGHT
}) {
  const personsFilter = permissions.get_own_direct_reports;
  const gridRef = useRef(null);
  const [editMode, setEditMode] = useState(false);
  const [presetId, setPresetId] = useState(null);
  const [groupBy, setGroupBy] = useState(initialGroupBy);
  const { UserFilterButton, filterModel } = usePersonFilter({ enabled: personsFilter });

  const toggleButtonGroupItems = useMemo(() => {
    return [
      { value: 'role', label: I18n.t('by_role') },
      { value: 'person', label: I18n.t('by_person') },
      { value: 'project', label: I18n.t('by_project') }
    ];
  }, []);

  return (
    <ResourceLayout
      personsFilter={personsFilter}
      permissions={permissions}
      left={<>
      {(permissions.create || permissions.update_cell || permissions.lock_cell || permissions.accept_cell)
        ? <Button type={editMode ? 'default' : 'primary'} onClick={() => setEditMode(prev => !prev)}>
            {!editMode
              ? <><FaIcon type='pencil' /> {I18n.t('edit')}</> 
              : I18n.t('cancel')
            }
          </Button>
        : null}
        <PresetDropdown
          presetId={presetId}
          setPresetId={setPresetId}
          projectId={projectId}
        />
        {UserFilterButton}
      </>}
      center={<>
        {!editMode && <ToggleButtonGroup
          value={groupBy}
          onChange={setGroupBy}
          items={toggleButtonGroupItems}
        />}
      </>}
    >
      <ResourceGrid
        {...{
          height,
          projectId,
          presetId,
          programmeId,
          months,
          groupBy,
          permissions,
          editMode,
          viewMode,
          gridRef,
          filterModel,
          personsFilter
        }}
      />
    </ResourceLayout>
  );
}

export default ResourceProgrammeList;
